<div class="content">
  <div class="header">
    <div class="title">{{ params.dateTitle }}</div>
    @if (params.subtitle) {
      <cs-note class="subtitle">{{ params.subtitle }}</cs-note>
    }
  </div>
  <cs-log-detail-content [sets]="params.sets"></cs-log-detail-content>
</div>
